import React, { useEffect, useRef, useState } from "react";
import Checkbox from "components/common/InputField/Checkbox";
import Button from "components/common/Button";
import { useNavigate } from "react-router-dom";
import AgentSideDrawer from "components/common/AgentSideDrawer";
import TextInput from "components/common/InputField/TextInput";
import ModalContainer from "components/common/ModalContainer";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import { workforceActions } from "redux/Ldb/actions";
import { saveToStorage } from "helpers";

type EDIAssistantProps = {
    currentStep: string;
    setCurrentStep: (step: string) => void;
    handleStepConfiguration: (value: boolean) => void;
    fetchedAllChannelsSuccess: Record<string, any>;
    selectedMarketingConnection: any[];
    setSelectedMarketingConnection: (any) => void;
    aiAgentName: string;
    setAiAgentName: (name: string) => void;
    agentDetails: Record<string, any>;
    agentSteps: Record<string, any>;
    agentId: string;
    aiTeammateId: string;
    avatar: string;
};

const EDIAssistant = ({
    currentStep,
    setCurrentStep,
    handleStepConfiguration,
    fetchedAllChannelsSuccess,
    selectedMarketingConnection,
    setSelectedMarketingConnection,
    aiAgentName,
    setAiAgentName,
    agentDetails,
    agentSteps,
    agentId,
    aiTeammateId,
    avatar,
}: EDIAssistantProps) => {
    const navigate = useNavigate();
    const modalRef = useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();

    const [signupInfo, setSignupInfo] = useState({
        email: "",
        password: "",
    });
    const [showWhy, setShowWhy] = useState<boolean>(false);
    const [spsSigninModal, setSpsSigninModal] = useState<boolean>(false);
    const [ediSource, setEdiSource] = useState<{ [key: string]: any }[]>([
        { name: "SPS Commerce", connection: null, key: "spsCommerce" },
    ]);

    const { createSpsCommerceConnectionSuccess, creatingSpsCommerceConnection } = useAppSelector(
        (state) => state.workforce
    );

    // useEffect(() => {
    //     const handleClickOutside = (event: MouseEvent) => {
    //         if (
    //             modalRef.current &&
    //             !modalRef.current.contains(event.target as Node) &&
    //             currentStep
    //         ) {
    //             setCurrentStep("");
    //         }
    //     };

    //     document.addEventListener("mousedown", handleClickOutside);

    //     return () => {
    //         document.removeEventListener("mousedown", handleClickOutside);
    //     };
    // }, [modalRef, currentStep]);

    const spsCommerceConnected = fetchedAllChannelsSuccess?.channel?.find(
        (item) => item?.channel?.toLowerCase() === "sps-commerce" && item?.active
    );

    useEffect(() => {
        if (spsCommerceConnected) {
            setEdiSource((prev) => [
                ...prev?.filter((item) => item?.key !== "spsCommerce"),
                {
                    name: "SPS Commerce",
                    connection: spsCommerceConnected,
                    key: "spsCommerce",
                },
            ]);
        }
    }, [spsCommerceConnected]);

    const handleCreateSpsCommerceConnection = (e) => {
        e.preventDefault();
        const body = {
            username: signupInfo.email,
            password: signupInfo.password,
        };

        dispatch(workforceActions.createSpsCommerceConnection(body));
    };

    const handleChange = (evt) => {
        const { name, value } = evt.target;

        setSignupInfo((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    useEffect(() => {
        if (createSpsCommerceConnectionSuccess) {
            const source = ediSource?.find((item) => item?.key === "spsCommerce");
            setSpsSigninModal(false);
            setSignupInfo({
                email: "",
                password: "",
            });

            setEdiSource((prev) => {
                return prev?.map((item) => {
                    if (item?.key === "spsCommerce") {
                        return {
                            ...item,
                            connection: createSpsCommerceConnectionSuccess,
                        };
                    }

                    return item;
                });
            });
            handleSelectCampaignSource(source);

            dispatch(workforceActions.resetCreateSpsCommerceConnectionSuccess());
        }
    }, [dispatch, createSpsCommerceConnectionSuccess, ediSource]);

    const handleSelectCampaignSource = (source: { [key: string]: any }) => {
        const selectedSource = [...selectedMarketingConnection];
        const findSource = selectedSource.find(
            (item) => item?.name?.toLowerCase() === source?.name?.toLowerCase()
        );

        if (findSource) {
            setSelectedMarketingConnection(
                selectedSource?.filter(
                    (item) => item?.name?.toLowerCase() !== source?.name?.toLowerCase()
                )
            );
            handleStepConfiguration(false);
        } else {
            setSelectedMarketingConnection([source]);
            handleStepConfiguration(true);
        }
    };

    return (
        <>
            {/* Select the source - action trigger */}

            <AgentSideDrawer open={currentStep === "source-action-tigger"} modalRef={modalRef}>
                <div className=" flex  !bg-white flex-col  font-rocGroteskMedium  ">
                    <div className="relative">
                        {" "}
                        <div className="px-6 flex justify-between py-6 items-center">
                            <p className="text-sm font-rocGroteskMedium text-slate-800">
                                Select the source - action trigger
                            </p>
                            <i
                                className="ri-close-fill text-xl text-slate-500 cursor-pointer border border-slate-200 rounded py-0 px-1"
                                onClick={() => {
                                    setCurrentStep("");
                                }}
                            ></i>
                        </div>
                        <div className="mx-6 border border-slate-200 p-4 rounded-lg">
                            <div className="space-y-4  pb-4">
                                {ediSource?.map((marketingConnection) => {
                                    const isSelected = [...selectedMarketingConnection]?.find(
                                        (item) =>
                                            item.name?.toLowerCase() ===
                                            marketingConnection.name?.toLowerCase()
                                    );

                                    return (
                                        <div
                                            key={marketingConnection.name}
                                            className="flex items-center justify-between"
                                        >
                                            <div className="flex items-center space-x-3">
                                                <Checkbox
                                                    name={marketingConnection.name?.toLowerCase()}
                                                    isChecked={Boolean(isSelected)}
                                                    required={
                                                        selectedMarketingConnection?.length === 0
                                                    }
                                                    disabled={!marketingConnection.connection}
                                                    onChange={(evt) => {
                                                        if (marketingConnection.connection) {
                                                            handleSelectCampaignSource(
                                                                marketingConnection
                                                            );
                                                        }
                                                    }}
                                                    className={
                                                        "!h-4 !w-4 !rounded-[4px] checked:!bg-y-10 "
                                                    }
                                                />

                                                <span className={`text-sm font-rocGroteskMedium `}>
                                                    {marketingConnection.name}
                                                </span>
                                            </div>

                                            {!marketingConnection.connection ? (
                                                <Button
                                                    btnText="Connect"
                                                    btnClassname="!px-4 !py-2 !bg-slate-50 !w-fit"
                                                    btnTextClassName="!text-b-55"
                                                    disabled={false}
                                                    onClick={() => {
                                                        setSpsSigninModal(true);
                                                    }}
                                                    icon={<i className="ri-add-fill text-b-55"></i>}
                                                />
                                            ) : (
                                                <div className="px-4 py-2 w-fit space-x-2 flex items-center h-10 rounded bg-slate-50">
                                                    <i className="ri-checkbox-circle-fill text-g-60"></i>
                                                    <span className="text-sm font-rocGroteskMedium text-g-60">
                                                        Connected
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="mt-4">
                                <p className="text-sm text-slate-500 p-3 bg-slate-100 border border-slate-200 rounded">
                                    This gives the AI teammate the ability to detect if there is a
                                    potential order that has been sent to your SPS Commerce account.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </AgentSideDrawer>

            <ModalContainer
                open={spsSigninModal}
                showCloseIcon={false}
                tailwindClassName="w-[38%] sm:w-[434px]"
                closeModal={() => {
                    setSpsSigninModal(false);
                }}
            >
                <div className="bg-white rounded-lg shadow-cardShadow relative">
                    <div className="px-6 pt-3 pb-5">
                        <div className="flex flex-col items-center text-center mb-6">
                            <div className="flex justify-end mr-[-12px] w-full">
                                <div className="bg-slate-100 rounded-full h-8 w-8 flex justify-center">
                                    <i
                                        onClick={() => setSpsSigninModal(false)}
                                        className="ri-close-fill text-2xl text-slate-500 cursor-pointer"
                                    ></i>
                                </div>
                            </div>
                            <p className="text-2xl mb-1.5 text-center  font-rocGroteskBold text-gm-50">
                                Enter sign in details
                            </p>
                            <p className="text-sm text-center font-rocGroteskMedium text-gm-35">
                                Enter your EDI sign in details to complete setup
                            </p>
                        </div>

                        <form onSubmit={handleCreateSpsCommerceConnection}>
                            <TextInput
                                value={signupInfo.email}
                                name={"email"}
                                type={"email"}
                                placeholder={"Enter email address"}
                                onChange={handleChange}
                                required={true}
                                containerClassname="mb-6 "
                                inputContainerClassname="!rounded-lg"
                            />
                            <TextInput
                                value={signupInfo.password}
                                name={"password"}
                                type={"password"}
                                onChange={handleChange}
                                placeholder={"Enter password"}
                                required={true}
                                containerClassname="mb-2"
                                inputContainerClassname="!rounded-lg"
                            />

                            <Button
                                btnText={`Save details`}
                                type="submit"
                                isLoading={creatingSpsCommerceConnection}
                                btnClassname="!mt-4 !w-fit !w-full !py-[14px] !px-4 "
                            />
                            <div className="mt-6 font-rocGroteskMedium py-2 px-3.5 w-fit  bg-slate-100 rounded-lg">
                                <div className="flex justify-between items-center gap-4 ">
                                    <p className="text-gm-45 text-xs">
                                        Why do we need your sign in details?
                                    </p>
                                    <i
                                        className={` ${
                                            showWhy ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                                        } text-slate-500 cursor-pointer `}
                                        onClick={() => setShowWhy(!showWhy)}
                                    ></i>
                                </div>
                                {showWhy && (
                                    <p className="text-xs text-gm-35 transition-all duration-500 ease-in-out mt-2">
                                        We use your sign in details to log into your EDI account and
                                        pull any information of orders you get there. Synth is
                                        unable to make any updates to any information on your EDI
                                        account.
                                    </p>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </ModalContainer>
        </>
    );
};

export default EDIAssistant;
